__turbopack_context__.v({
  "button": "style-module-scss-module__VlMjYW__button",
  "close-button": "style-module-scss-module__VlMjYW__close-button",
  "component": "style-module-scss-module__VlMjYW__component",
  "custom-position": "style-module-scss-module__VlMjYW__custom-position",
  "full-map-button": "style-module-scss-module__VlMjYW__full-map-button",
  "full-screen-map": "style-module-scss-module__VlMjYW__full-screen-map",
  "full-screen-map-container": "style-module-scss-module__VlMjYW__full-screen-map-container",
  "full-screen-overlay": "style-module-scss-module__VlMjYW__full-screen-overlay",
  "is-zoo": "style-module-scss-module__VlMjYW__is-zoo",
  "satellite-toggle-button": "style-module-scss-module__VlMjYW__satellite-toggle-button",
  "title-container": "style-module-scss-module__VlMjYW__title-container",
  "zoom-control-group": "style-module-scss-module__VlMjYW__zoom-control-group",
});
